export { AvataaarDefault } from "./AvataaarDefault";
